/** Boje traka po tipu entiteta — vrijednosti su enum imena koja vraća backend. */
export const TIMELINE_BAR_COLORS: Record<string, string> = {
  VehicleRegistration: "bg-sky-500",
  VehicleInsurance: "bg-violet-500",
  FireExtinguisher: "bg-red-500",
  Offer: "bg-amber-500",
  Contract: "bg-emerald-500",
  Invoice: "bg-slate-500",
};

export const DEFAULT_TIMELINE_BAR_COLOR = "bg-slate-400";

export const WEEKDAY_SHORT_NAMES = ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"];

export const MONTH_NAMES = [
  "Siječanj",
  "Veljača",
  "Ožujak",
  "Travanj",
  "Svibanj",
  "Lipanj",
  "Srpanj",
  "Kolovoz",
  "Rujan",
  "Listopad",
  "Studeni",
  "Prosinac",
];
